import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
import MainLayout from "layout/MainLayout";
import {
  OrganizationMain,
  OrganizationReview,
  OrganizationAd,
  TopAds,
} from "../Contents";
import { useParams } from "react-router-dom";

const OrganizationDashboard = () => {
  const [content, setContent] = useState<any>(<OrganizationMain org={""} />);

  const { orgName } = useParams();

  useEffect(() => {
    if (orgName === "") return;
    setContent(<OrganizationMain org={orgName as string} />);
  }, [orgName]);

  return (
    <MainLayout title={orgName}>
      <div className="containers my-16 flex gap-12 flex-col xl:flex-row lg:px-[60px] sm:my-[24px]">
        <div className="flex flex-col xl:flex-row w-full gap-12">
          <div className="flex flex-col gap-10 sm:gap-[24px]">
            <div className="flex xl:flex-col flex-wrap gap-10 sm:gap-[16px]">
              <img
                src={cookie.load("user")?.media}
                alt="background"
                className="max-w-[225px] min-w-[225px] max-h-[150px] min-h-[150px] sm:max-w-[150px] sm:min-w-[150px] sm:max-h-[90px] sm:min-h-[90px]"
              />
              <div className="flex flex-col grow">
                <span
                  className="text-3xl font-mont text-main xl:w-[225px] block sm:text-2xl cursor-pointer sm:mb-2"
                  onClick={() =>
                    setContent(<OrganizationMain org={orgName as string} />)
                  }
                >
                  {orgName}
                </span>
                <div className="flex xl:flex-col gap-[8px] ml-auto xl:ml-0 mt-auto xl:mt-10">
                  <button
                    className="main-button"
                    onClick={() =>
                      setContent(<OrganizationAd org={orgName as string} />)
                    }
                  >
                    ADS
                  </button>
                  <button
                    className="main-button"
                    onClick={() =>
                      setContent(<OrganizationReview org={orgName as string} />)
                    }
                  >
                    REVIEWS
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="grow flex flex-col">{content}</div>
          {cookie.load("user").organization.toLowerCase() === "gyde" && (
            <TopAds />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default OrganizationDashboard;
